import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import EcoSpace from 'eco-design/base/eco-space';
import EcoCompareSelector from 'eco-design/sections/eco-compare-selector';
import { EcoCompareSelectorItemType } from 'eco-design/sections/eco-compare-selector/type';
import React, { useState } from 'react';
import { GeneralKeys } from '../../../../config/pageConfig';
import { useProductStore } from '../../../../ProductProvider';
import Dialog from '../PowerSolution/Dialog';
import style from './index.module.scss';
import { useSpec } from './useSpec';

const JP_KEYS = [
    'Capacity',
    'specs_ports',
    'specs_wired_charging_input',
    'specs_wired_charging_output',
    'rapid_wireless_output',
    'specs_app',
    'specs_digital_display',
    'rapid_dimensions',
    'rapid_weight',
    'specs_color',
];

const EU_KEYS = [
    'Capacity',
    'rapid_dimensions',
    'rapid_weight',
    'specs_ports',
    'specs_wired_charging_output',
    'rapid_wireless_output',
    'specs_wired_charging_input',
    'specs_app',
    'specs_digital_display',
];

const CompareSelector: React.FC = ({}) => {
    const { t } = useLang('theProduct.CompareSelector');
    const { t: t2 } = useLang('theProduct.PowerSolution');
    const { productInfo } = useProductStore();
    const { locale = 'jp' } = getLocal();

    const IS_JP = locale === 'jp';
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale);

    const [showNotifyMeModal, setShowNotifyMeModal] = useState(false);

    // 获取「比较参数」
    const subs = useSpec(GeneralKeys, IS_JP ? JP_KEYS : EU_KEYS);
    // 整合数据
    const item = productInfo?.map((i, idx) => {
        let title = i.children?.find((child) => child?.productTitle)?.productTitle || '';
        if (IS_EU && idx > 1) {
            title = t2(`item${idx + 1}`);
        }
        const selectOptions: any[] = [];

        productInfo?.map((n, j) => {
            selectOptions.push({
                label: IS_EU && j > 1 ? t2(`item${j + 1}`) : n.children[0].productTitle,
                value: IS_EU && j > 1 ? t2(`item${j + 1}`) : n.children[0].productTitle,
            });
        });
        return {
            label: idx < 2 ? t('new') : t('old'),
            title,
            items: selectOptions,
            colors: i.children?.map((j, jk) => ({
                ...j,
                btns: [
                    ((locale === 'us' && [0, 1, 3].includes(idx)) || (locale === 'ca' && [0, 1].includes(idx))) &&
                    j.variantId !== '54593884684361' &&
                    j.variantId !== '52731646509427'
                        ? {
                              className: 'notify-me',
                              text: t2('notify-me'),
                              type: 'filled',
                              onClick: () => {
                                  setShowNotifyMeModal(true);
                              },
                          }
                        : {
                              href: `https://${locale}.ecoflow.com/cart/${j.variantId}:1?channel=buy_button`,
                              text: IS_JP && j.lDisabled ? t('buynow2') : t('buynow'),
                              type: 'filled',
                              dataLayer: {
                                  event: 'uaEvent',
                                  event_name: 'checkout',
                                  button_name: `${t('buynow')}_${title}`,
                                  __btn_id1: `${style.comp} .filled-${jk + 1}`,
                                  __btn_id2: IS_JP && j.lDisabled ? t2('notify-me') : `https://${locale}.ecoflow.com/cart/${j.variantId}:1?channel=buy_button`,
                                  __btn_type: IS_JP && j.lDisabled ? 'text' : 'href',
                              },
                              disabled: j.lDisabled,
                          },
                    t('more') &&
                        !j.lDisabled && {
                            href: `https://${locale}.ecoflow.com/products/${j.handle}?variant=${j.variantId}`,
                            text: t('more'),
                            type: 'text',
                            icon: true,
                            dataLayer: {
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: title,
                                position: `Collections_${t('title')}`,
                                __btn_id1: `${style.comp} .text-${jk + 1}`,
                                __btn_id2: `https://${locale}.ecoflow.com/products/${j.handle}?variant=${j.variantId}`,
                                __btn_type: 'href',
                            },
                        },
                ],
            })),
            subs: subs[idx] ?? [],
        };
    });

    if (!productInfo) return <div id="CompareSelector"></div>;

    return (
        <div className={`CompareSelector GtmModuleData-section`} id="CompareSelector" data-section-id="CompareSelector">
            <EcoSpace />
            <EcoCompareSelector
                className={style.comp}
                title={t('title')}
                linkProps={{
                    className: 'GtmModuleData-btn-href link-desc',
                    dataLayer: {
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: 'EcoFlow RAPID Mag',
                        position: `Collections_${t('link')}`,
                        __btn_id1: `${style.comp} .link-desc`,
                        __btn_id2: IS_JP
                            ? `https://${locale}.ecoflow.com/collections/power-bank#rapid-mag`
                            : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag`,
                        __btn_type: 'href',
                    },
                    href: IS_JP
                        ? `https://${locale}.ecoflow.com/collections/power-bank#rapid-mag`
                        : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag`,
                    children: (
                        <>
                            <span>{t('link')}</span>
                            <EcoIconArrow />
                        </>
                    ),
                }}
                items={item as EcoCompareSelectorItemType[]}
            />
            {['eu', 'uk', 'de', 'fr', 'es', 'it'].includes(locale) && <EcoSpace />}
            <Dialog open={showNotifyMeModal} onClose={() => setShowNotifyMeModal(false)} />
        </div>
    );
};
export default CompareSelector;
